// Angular
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

// App services
import { TokenService } from '@app/core/services';


export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const accessToken = inject(TokenService).getAccessToken();

  if (!accessToken) {
    return next(req);
  }

  return next(req.clone({
    setHeaders: { Authorization: `Bearer ${accessToken}` },
  }));
};
